import React from "react";
import { Box, Chip, IconButton } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import ReactHtmlParser from "html-react-parser";

import HoverablePaper from "components/Shared/HoverablePaper";
import FileIcon from "components/Shared/FileIcon";

import { useAuth } from "hooks";

import { humanizeDate, localizeDateTimeMed } from "utils/dateFormats";

const ResponseListItem = ({ response, onEditAction }) => {
  const { checkIfAuthor, getAuthorName, isVendor } = useAuth();

  return (
    <Box paddingY={3} key={response?._id}>
      <div className="grid grid-cols-1 gap-4">
        <div className="relative flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="grid aspect-square w-8 place-content-center rounded-full border bg-blue-100 text-blue-500 dark:border-gray-400 dark:bg-gray-700 dark:text-blue-200">
              {response?.createdBy?.name?.charAt(0)?.toUpperCase()}
            </div>

            <div>
              {getAuthorName(response?.createdBy)} ,{" "}
              <span className="text-sm text-gray-500 dark:text-gray-300">
                responded {humanizeDate(response?.createdAt)}
              </span>{" "}
              {!isVendor && (
                <Chip
                  label={response.type}
                  size="small"
                  color="primary"
                  sx={{ ml: 1, textTransform: 'capitalize' }}
                />
              )}
              {response?.updatedBy && (
                <span className="text-gray-500">
                  Edited {localizeDateTimeMed(response?.updatedAt)}
                </span>
              )}
            </div>
          </div>

          {checkIfAuthor(response?.createdBy) && (
            <IconButton size="small" onClick={() => onEditAction(response)}>
              <EditOutlined />
            </IconButton>
          )}
        </div>

        <div className="relative">
          <div class="absolute -top-2.5 ml-2.5 h-0 w-0 border-x-[6px] border-b-[10px] border-x-transparent  border-b-blue-100 dark:border-b-gray-700" />

          <HoverablePaper
            variant="outlined"
            className="grid grid-cols-1 gap-3 px-4 py-4"
          >
            {response?.content && (
              <div>{ReactHtmlParser(response?.content)}</div>
            )}

            {!!response?.attachments?.length && (
              <div className="flex gap-4">
                {response?.attachments?.map((attachment) => (
                  <a
                    key={attachment?._id}
                    href={attachment?.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "var(--primary)" }}
                  >
                    <FileIcon
                      fileName={attachment?.name}
                      fileUrl={attachment?.url}
                    />
                  </a>
                ))}
              </div>
            )}
          </HoverablePaper>
        </div>
      </div>
    </Box>
  );
};

export default ResponseListItem;
